import type { MonthGrouping, ZillowHomeValueIndexTrendsData } from '../zillow/types.ts';

export type TrendsChartDataType = {
  inner: MonthGrouping;
  month: string;
  historical: number | null;
  projection: number | null;
  comps?: string;
};

export const getHousingTrendsChartData = (
  trends?: ZillowHomeValueIndexTrendsData,
): TrendsChartDataType[] => {
  if (!trends) return [];

  const data: TrendsChartDataType[] = trends.historical.map((val, i) => ({
    inner: val,
    month: val.month,
    historical: val.typicalValue.toDollarLike(),
    // Workaround to draw a line for projection
    projection: i === trends.historical.length - 1 ? val.typicalValue.toDollarLike() : null,
    comps: val.affectedComps,
  }));

  data.push(
    ...(trends.projection ?? []).map((val) => ({
      inner: val,
      month: val.month,
      historical: null,
      projection: val.typicalValue.toDollarLike(),
      comps: val.affectedComps,
    })),
  );

  return data;
};
